import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import authReducer from "@slices/authSlice";
import roleBasedPropertyReducer from "@slices/roleBasedPropertySlice";
import httpStatusReducer from "@slices/httpStatusSlice";
import loaderReducer from "@slices/loaderSlice";
import donationReducer from "@slices/donationSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        roleBasedProperty: roleBasedPropertyReducer,
        httpStatus: httpStatusReducer,
        loaderCount: loaderReducer,
        donation: donationReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
